function parseCartSectionHTML(html, selector) {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const node = doc.querySelector(selector || '.shopify-section');
  return node ? node.innerHTML : '';
}

function paintCartIconFromSections(sections) {
  const link = document.getElementById('cart-icon-bubble');
  if (!link || !sections || !sections['cart-icon-bubble']) return false;

  const innerHTML = parseCartSectionHTML(sections['cart-icon-bubble']);
  if (!innerHTML) return false;

  link.innerHTML = innerHTML;
  return true;
}

function paintCartDrawerFromSections(sections) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !sections || !sections['cart-drawer']) return false;

  const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
  const newDrawer = doc.querySelector('cart-drawer');
  if (!newDrawer) return false;

  cartDrawer.classList.remove('is-empty');
  cartDrawer.innerHTML = newDrawer.innerHTML;
  return true;
}

function paintCartIconFromCart(cart) {
  const link = document.getElementById('cart-icon-bubble');
  if (!link || !cart || typeof cart.item_count !== 'number') return;

  let countEl = link.querySelector('.cart-count-bubble [aria-hidden="true"]');
  let bubble = link.querySelector('.cart-count-bubble');

  if (cart.item_count > 0) {
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      bubble.appendChild(countSpan);
      link.appendChild(bubble);
      countEl = countSpan;
    }
    if (countEl) countEl.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
  } else if (bubble) {
    bubble.remove();
  }
}

function refreshCartIconBubble() {
  const link = document.getElementById('cart-icon-bubble');
  if (!link) return Promise.resolve(false);

  const sectionsUrl = `${window.location.pathname || '/'}?sections=cart-icon-bubble`;

  return fetch(sectionsUrl)
    .then((response) => response.json())
    .then((data) => {
      if (paintCartIconFromSections(data)) return true;
      return fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          if (cart && typeof cart.item_count === 'number') paintCartIconFromCart(cart);
        });
    })
    .catch(() => false);
}

function refreshCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return Promise.resolve(false);

  const sectionsUrl = `${window.location.pathname || '/'}?sections=cart-drawer`;

  return fetch(sectionsUrl)
    .then((response) => response.json())
    .then((data) => paintCartDrawerFromSections(data))
    .catch(() => false);
}

function refreshCartUI(sections) {
  if (sections) {
    paintCartDrawerFromSections(sections);
    paintCartIconFromSections(sections);
    return;
  }

  refreshCartDrawer();
  refreshCartIconBubble();
}

window.paintCartIconFromSections = paintCartIconFromSections;
window.paintCartDrawerFromSections = paintCartDrawerFromSections;
window.refreshCartIconBubble = refreshCartIconBubble;
window.refreshCartDrawer = refreshCartDrawer;
window.refreshCartUI = refreshCartUI;

function mieClearCartErrorsGlobal() {
  const cartErrors = document.getElementById('CartDrawer-CartErrors');
  if (cartErrors) {
    cartErrors.textContent = '';
    cartErrors.hidden = true;
    cartErrors.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('.cart-item__error-text').forEach((el) => {
    el.textContent = '';
  });
}

window.mieClearCartErrorsGlobal = mieClearCartErrorsGlobal;

function hookCartAddFetch() {
  if (window.__cartIconFetchHooked) return;
  window.__cartIconFetchHooked = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    return nativeFetch(input, init).then((response) => {
      let url = '';
      if (typeof input === 'string') url = input;
      else if (input && input.url) url = input.url;

      if (url.includes('/cart/add') || url.includes('/cart/change')) {
        response
          .clone()
          .json()
          .then((data) => {
            if (!data || data.status) return;
            mieClearCartErrorsGlobal();
            if (data.sections) refreshCartUI(data.sections);
          })
          .catch(() => {});
      }

      return response;
    });
  };
}

function initCartIconUpdates() {
  if (window.__cartIconPubSubInit) return;
  window.__cartIconPubSubInit = true;

  hookCartAddFetch();

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    if (data && data.source === 'cart-items') return;

    if (data && data.cartData && data.cartData.sections) {
      refreshCartUI(data.cartData.sections);
      return;
    }
    refreshCartUI();
  });

  subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
    refreshCartUI();
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlayClose();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlayClose() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay || overlay.dataset.mieBound === 'true') return;
    overlay.dataset.mieBound = 'true';
    overlay.addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || cartLink.dataset.mieDrawerBound === 'true') return;

    cartLink.dataset.mieDrawerBound = 'true';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
      refreshCartDrawer().then(() => {
        this.showDrawer();
      });
      return;
    }

    this.showDrawer();
  }

  showDrawer() {
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');

    if (parsedState) this.productId = parsedState.id;

    if (parsedState && parsedState.sections) {
      paintCartDrawerFromSections(parsedState.sections);
      paintCartIconFromSections(parsedState.sections);
    } else {
      refreshCartUI();
    }

    setTimeout(() => {
      this.bindOverlayClose();
      this.open();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

if (typeof CartItems !== 'undefined') {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      if (!html) return '';
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const node = doc.querySelector(selector) || doc.querySelector('.shopify-section');
      return node ? node.innerHTML : '';
    }

    mieClearCartErrors() {
      mieClearCartErrorsGlobal();
    }

    mieShowCartError() {
      mieClearCartErrorsGlobal();
    }

    mieSafeEnableLoading() {
      const mainCartItems = document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    }

    mieSafeDisableLoading() {
      const mainCartItems = document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');

      document.querySelectorAll('#CartDrawer-CartItems .loading__spinner').forEach((spinner) => {
        spinner.classList.add('hidden');
      });
    }

    mieShowLineError(line, message) {
      const lineItemError = document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (!lineItemError) return;

      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) errorText.textContent = message;
    }

    updateQuantity(line, quantity, event, name, variantId) {
      this.mieSafeEnableLoading();
      mieClearCartErrorsGlobal();

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((state) => {
          let parsedState;

          try {
            parsedState = JSON.parse(state);
          } catch (error) {
            mieClearCartErrorsGlobal();
            return;
          }

          if (parsedState.errors) {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            this.mieShowLineError(line, parsedState.errors);
            return;
          }

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          if (cartDrawerWrapper) {
            cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          }

          if (parsedState.sections) {
            paintCartDrawerFromSections(parsedState.sections);
            paintCartIconFromSections(parsedState.sections);
          } else {
            refreshCartDrawer();
            refreshCartIconBubble();
          }

          mieClearCartErrorsGlobal();

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cartData: parsedState,
              variantId: variantId,
            });
          }
        })
        .catch(() => {
          mieClearCartErrorsGlobal();
        })
        .finally(() => {
          this.mieSafeDisableLoading();
          mieClearCartErrorsGlobal();
        });
    }
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define('cart-drawer-items', CartDrawerItems);
  }
}

initCartIconUpdates();
